import { useSidebarSummaryContext } from '../../SidebarSummary.context';
import { SidebarType } from '../../types/SidebarType';
import { FinalAnimation } from './components/FinalAnimation/FinalAnimation';
import { OpenAnswerAnimation } from './components/OpenAnswerAnimation/OpenAnswerAnimation';
import { RankingAnimation } from './components/RankingAnimation/RankingAnimation';
import { SurveyAnimation } from './components/SurveyAnimation/SurveyAnimation';

export const AnimatedSidebarSummary = ({
  hideAnimationFinished,
  handleAnimationEnd,
  showLastAnimation,
  isFullWidthActive,
}: {
  hideAnimationFinished: boolean;
  handleAnimationEnd: (forceShowComponent?: boolean) => void;
  showLastAnimation: boolean;
  isFullWidthActive: boolean;
}) => {
  const { type } = useSidebarSummaryContext();

  const handleLastAnimationEnd = () => {
    handleAnimationEnd(true);
  };

  if (showLastAnimation) {
    return (
      <FinalAnimation
        hideAnimation={hideAnimationFinished}
        onAnimationEnd={handleLastAnimationEnd}
      />
    );
  }

  switch (type) {
    case SidebarType.OpenAnswer:
      return (
        <OpenAnswerAnimation
          hideAnimation={hideAnimationFinished}
          onAnimationEnd={handleAnimationEnd}
        />
      );
    case SidebarType.Survey:
      return (
        <SurveyAnimation
          hideAnimation={hideAnimationFinished}
          onAnimationEnd={handleAnimationEnd}
        />
      );
    case SidebarType.Ranking:
      return (
        <RankingAnimation
          isFullWidthActive={isFullWidthActive}
          hideAnimation={hideAnimationFinished}
          onAnimationEnd={handleAnimationEnd}
        />
      );
    default:
      console.error(`Sidebar type ${type} not supported`);
      return null;
  }
};
